import { Reducer, configureStore } from '@reduxjs/toolkit'
import createSagaMiddleware, { Saga } from 'redux-saga'
import persistReducer from 'redux-persist/es/persistReducer'
import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
} from 'redux-persist'
import persistStore from 'redux-persist/es/persistStore'
import storage from 'redux-persist/lib/storage'
import { REDUX_PERSIST_CONSTANTS } from './utils/constants'

const createStore = <T>(
  reducer: Reducer<T>,
  rootSaga: Saga,
  customStorage = storage
) => {
  const sagaMiddleware = createSagaMiddleware()
  const middleware = [sagaMiddleware]

  const persistConfig = {
    key: REDUX_PERSIST_CONSTANTS.ROOT,
    storage: customStorage,
    whitelist: [
      REDUX_PERSIST_CONSTANTS.ROLE,
      REDUX_PERSIST_CONSTANTS.TOAST,
      REDUX_PERSIST_CONSTANTS.TABLE_COLUMN,
      REDUX_PERSIST_CONSTANTS.HCP_AUTH,
      REDUX_PERSIST_CONSTANTS.HCP_ONBOARDING,
      REDUX_PERSIST_CONSTANTS.AUTH_REMEMBER,
      REDUX_PERSIST_CONSTANTS.CALL_INTERACTOIN,
      REDUX_PERSIST_CONSTANTS.PERMISSIONS,
      REDUX_PERSIST_CONSTANTS.PAGINATION,
      REDUX_PERSIST_CONSTANTS.CLIENT_PROGRAMS,
      REDUX_PERSIST_CONSTANTS.LOCAL_COMMON,
      REDUX_PERSIST_CONSTANTS.AWS,
    ],
    blacklist: [],
  }

  const persistedReducer = persistReducer(persistConfig, reducer)

  const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
          warnAfter: 200,
        },
      }).concat(middleware),
  })

  const persist = persistStore(store)
  sagaMiddleware.run(rootSaga)
  return { store, persist }
}

export default createStore
